import { Point } from "../models/Point";
import { EncodingUtils } from "../utils/EncodingUtils";
import { SvgUtils } from "../utils/SvgUtils";
import { VisualizerBase } from "./VisualizerBase";

export class Scroll extends VisualizerBase {
    idSign: string;
    constructor(_placeholderMode: boolean = false) {
        super("scroll", _placeholderMode);
        this.idSign = `lines_sign_${this.chainIdName}`;
    }

    // createSign0(defs: SVGDefsElement){
    //     const lineA = SvgUtils.createLine(40, 48.5, 190, 48.5, "", 5);
    //     const line1 = SvgUtils.createLine(80, 99, 180, 99, "", 3);
    //     const line2 = SvgUtils.createLine(80, 129, 180, 129, "", 3);
    //     const line3 = SvgUtils.createLine(80, 159, 180, 159, "", 3);
    //     const lineB = SvgUtils.createLine(70, 208.5, 220, 208.5, "", 5);

    //     const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
    //     g.id = this.idSign;
    //     g.appendChild(lineA);
    //     g.appendChild(line1);
    //     g.appendChild(line2);
    //     g.appendChild(line3);
    //     g.appendChild(lineB);
    //     defs.appendChild(g);
    // }

    createSign(defs: SVGDefsElement){
        const lineA1 = SvgUtils.createLine(32.5, 45, 32.5, 75, "", 9);
        const lineA2 = SvgUtils.createLine(35, 47.5, 185, 47.5, "", 9);
        const lineA3 = SvgUtils.createLine(187.5, 45, 187.5, 177, "", 9);
        const line1 = SvgUtils.createLine(77, 98.5, 177, 98.5, "", 5);
        const line2 = SvgUtils.createLine(77, 128.5, 177, 128.5, "", 5);
        const line3 = SvgUtils.createLine(77, 158.5, 177, 158.5, "", 5);
        const lineB1 = SvgUtils.createLine(61.5, 78, 61.5, 210, "", 9);
        const lineB2 = SvgUtils.createLine(64, 207.5, 214, 207.5, "", 9);
        const lineB3 = SvgUtils.createLine(216.5, 180, 216.5, 210, "", 9);

        const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
        g.id = this.idSign;
        g.setAttribute("transform", `scale(0.4)`);
        g.appendChild(lineA1);
        g.appendChild(lineA2);
        g.appendChild(lineA3);
        g.appendChild(line1);
        g.appendChild(line2);
        g.appendChild(line3);
        g.appendChild(lineB1);
        g.appendChild(lineB2);
        g.appendChild(lineB3);
        defs.appendChild(g);
    }

    public override generate(hex: string, coreMode: boolean = false): SVGSVGElement {
        const svg = this.createSvg();
        this.hexArray = EncodingUtils.hexStringToHexArray(hex);

        const size = 320;
        const center = size / 2;
        const height = 70;
        const triangleLength = height;
        const htl = triangleLength / 2;
        const x00 = height * Math.tan(25 * Math.PI / 180);
        const sr3 = Math.sqrt(3);
        const sr3HTL = sr3 * x00;
        const htl2 = x00 + 10;

        const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");

        if(!coreMode) {
            const idOB = `circleOutbounding_${this.chainIdName}`;
            const dOB = SvgUtils.getDOfPathOfCircle(0, 0, 150);
            const obCircle = document.createElementNS("http://www.w3.org/2000/svg", "path");
            obCircle.id = idOB;
            obCircle.setAttribute("d", `${dOB}`);
            defs.appendChild(obCircle);
        }

        const points: Array<Point> = [ new Point(0, 70),
            new Point(x00, 0),
            new Point(0, -70),
            new Point(-x00, 0)
        ];
        const polygonId = `polygon_50deg_70_${this.chainIdName}`;
        const polygon = SvgUtils.createPolygonPath(polygonId, points, true, ``, "", 0);
        defs.appendChild(polygon);

        this.createSign(defs);
        svg.appendChild(defs);
        
        if(!coreMode) {
            // outbound: moving 3 circles
            this.appendMovingCirclesOutbound(svg, 150);
            // outbound: scaling circle
            this.appendDynamicScalingOutbound(svg, 1.4);
        }

        const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        // 0: rotate
        const angle = this.placeholderMode ? 0 : parseInt(this.hexArray[0], 16);

        // polygon-1
        this.addUsePartToGroup(group, polygonId, `translate(0 -80)`, this.getColorHex(1, 2, 3), "", 0);
        // polygon-2
        this.addUsePartToGroup(group, polygonId, `translate(${htl2} 0)`, this.getColorHex(4, 5, 6), "", 0);
        // polygon-3
        this.addUsePartToGroup(group, polygonId, `translate(0 80)`, this.getColorHex(7, 8, 9), "", 0);
        // polygon-4
        this.addUsePartToGroup(group, polygonId, `translate(-${htl2} 0)`, this.getColorHex(10, 11, 12), "", 0);

        // sign-left
        this.addUsePartToGroup(group, this.idSign, `translate(-60 -55) scale (-1,1)`, "", this.getColorHex(13, 14, 15), 0);
        // sign-right
        this.addUsePartToGroup(group, this.idSign, `translate(60 -55)`, "", this.getColorHex(16, 17, 18), 0);
        
        group.setAttribute("transform", `rotate(${angle},${center},${center}) translate(${center} ${center})`);
        svg.appendChild(group);
        return svg;
    }

}